import { state as stateApp } from '../app.logic'
import moment from 'moment'

export const dateFormat = ({ text, format }) => {
    if (!text) {
        return null;
    }
    let result = moment(text);
    if (stateApp.locale === "th") {
        result = result.add(543, "years");
    }
    return result.format(format);
}